import React from "react";

interface GridRowProps {
  name: string;
  value: string | number | null;
  style?: {
    fontWeight?: string;
  };
}

const GridRow = (props: GridRowProps) => {
  const style = props.style || {};
  return (
    <div className="grid">
      <div className="col-3">
        <p>{props?.name}:</p>
      </div>
      <div className="col-9">
        <p className={style.fontWeight}>{props?.value}</p>
      </div>
    </div>
  );
};

export default GridRow;
